export const shouldIncludeThdDefaultLightTheme = (theme) => {
  return [
    'EndcapLightGreen',
    'EndcapDarkGreen',
    'EndcapSawdust',
    'EndcapBeige'
  ].includes(theme);
};